export const path = (path) => (request) => ({
    ...request,
    url: (request.url || '') + path,
});
